import { ReactElement } from 'react';

import { useNavigation } from '@refinedev/core';

import { ArrowLeftIcon, Loading } from '@rrexpress/core';

import { BaseCard } from '../card';

export interface IBaseCreate {
  title: string;
  children: ReactElement;
  isLoading?: boolean;
  hideBack?: boolean;
}

export const BaseCreate: React.FC<IBaseCreate> = (props: IBaseCreate) => {
  const {
    title, children, isLoading, hideBack,
  } = props;

  const { goBack } = useNavigation();

  return (
    <div>
      {isLoading
        && <div className="mb-8 flex font-bold items-center justify-center space-x-2">
          <Loading
            variant="circular"
            size={40}
            speed={0.6}
            indicatorCap="round"
          />
        </div>
      }
      <div className={isLoading ? 'hidden' : ''}>
        <BaseCard>
          <div className="mb-8 flex gap-2 font-bold items-center text-[#444444]">
            {!hideBack && (
              <div
                className="hover:text-gray-400 cursor-pointer"
                onClick={() => goBack()}
              >
                <ArrowLeftIcon />
              </div>
            )}
            <h1 className="text-xl">{title}</h1>
          </div>
          {children}
        </BaseCard>
      </div>
    </div>
  );
};
